export default __webpack_public_path__ + "static/media/visitor_overview_en.26fcbedb.svg";